// extracted by mini-css-extract-plugin
export default {"Clickable":"CollapsibleRow_Clickable__OSVW7"};